module.exports = __webpack_public_path__ + "img/advantages-bg.d2991ff.jpg";